import $ from "jquery";
import { addressFormatter } from "../framework/addressFormatter";
import { dataaccess } from "../dataaccess/dataContext";
import { countryState } from "./countryState";
import Dropzone from "dropzone";
import "dropzone/dist/dropzone.css";
import { forms } from "../framework/forms";
import { services } from "../services/notificationService";
import intlTelInput from 'intl-tel-input';

let isEditing = false;
const originalValues = [];
let itiPhone = {};

function init() {
    itiPhone = intlTelInput(document.querySelector("#txtEditSitePhoneNumber"), { utilsScript: "/dist/utils.js", autoPlaceholder: "aggressive", initialCountry: $("#txtSelectedCountry").val() });
    editSiteSaveOriginalValues();
    addEvents();
    initiateDropzone();
}

function addEvents() {
    $(document).on("click", "#btnEditSiteProfileEdit", evtbtnEditSiteProfileEditClick);
    $(document).on("click", "#btnEditSiteProfileCancel", evtbtnEditSiteProfileCancelClick);
    $(document).on("change", "#ddlEditSiteCountryCode", evtddlEditSiteCountryCodeChange);
    $(document).on("change", "#ddlEditSiteStateId", evtddlEditSiteStateIdChange);
    $(document).on("click", "#btnEditSiteSaveEdit",validateAndSubmitForm);
    $(document).on("change", "#txtEditSitePhoneNumber", function () {
        $("#validationPhoneSpan").addClass("hidden");
        if (!itiPhone.isValidNumber()) {
            $("#validationPhoneSpan").removeClass("hidden");
        }
    });
}

function initiateDropzone() {
    const siteId = $("#siteId").val();
    const previewNode = document.querySelector("#Template");
    previewNode.id = "";
    const previewTemplate = previewNode.parentNode.innerHTML;
    previewNode.parentNode.removeChild(previewNode);

    const myDropzone = Dropzone.forElement("#Uploader");

    myDropzone.options.addRemoveLinks = true;
    myDropzone.options.autoProcessQueue = false;
    myDropzone.options.disablePreview = true;
    myDropzone.options.parallelUploads = 100;
    myDropzone.options.uploadMultiple = false;
    myDropzone.options.previewTemplate = previewTemplate;
    myDropzone.options.previewsContainer = "#PreviewTemplateParent";

    myDropzone.on("queuecomplete", function () {
        this.removeAllFiles();
    });

    myDropzone.on("error", function (file, response) {
        services.notificationService.error(response);
    });

    myDropzone.on("success", function (file, response) {
        location.reload();
    });

    myDropzone.on("addedfile", function () {
        if (this.files.length > 0) {
            $("#UploadBtn").show();
        }
    });

    myDropzone.on("removedfile", function () {
        if (this.files.length === 0) {
            $("#UploadBtn").hide();
        }
    });

    myDropzone.on("sending", function (file, xhr, formData) {
        formData.append("SiteId", siteId);
    });

    myDropzone.on("complete", function () {
        location.reload();
    });

    $("#UploadBtn").click(function () {
        let isValid = true;

        //$(".dz-preview").each(function (index, item) {
        //    $(this).find("select[name=FileCategoryIds]").removeClass("error text-danger");
        //    $(this).find(".dz-error-message").hide();
        //    $(this).find(".js-val-error").text("");

        //    const selectValue = $(this).find("select[name=FileCategoryIds]").val();

        //    if (selectValue === "" || selectValue === undefined) {
        //        isValid = false;
        //        $(this).find("select[name=FileCategoryIds]").addClass("error text-danger");
        //        $(this).find(".js-val-error").text("File Category is required.");
        //    }
        //});

        if (isValid) {
            forms.disableSubmitButton();
            forms.showSpinner("Uploading...", false);
            myDropzone.processQueue();
        }
    });
}


//
//Event handlers
//
function evtbtnEditSiteProfileEditClick() {
    editSiteToggleEditProfile();
}

function evtbtnEditSiteProfileCancelClick() {
    editSiteToggleEditProfile();
}

function evtddlEditSiteCountryCodeChange() {
    const selectedCountry = $("#ddlEditSiteCountryCode").val();
    itiPhone.setCountry(selectedCountry);
    $("#txtEditSiteCountryCode").val(selectedCountry);
    countryState.populateStatesSelect("#divEditSiteNaState", "#divEditSiteNonNaState", selectedCountry);
    addressFormatter.maskPhone($("#txtEditSitePhoneNumber"), selectedCountry);
    addressFormatter.maskPhone($("#txtFax"), selectedCountry);
    addressFormatter.maskZip($("#txtEditSitePostalCode"), selectedCountry);
    addressFormatter.showIfUsOrCa($("#EditSiteNaPostalReq"), selectedCountry);

    if (addressFormatter.isUsOrCa(selectedCountry)) {
        $("#txtEditSiteNonNaState").val("");
    }
    if (isEditing) {
        $("#ddlEditSiteStateId").val("");
        $("#txtEditSiteStateId").val("");
        $("#ddlEditSiteAreaId").val("");
        $("#txtEditSiteAreaId").val("");
    }
    editSiteCalculateRegionId();
}
function evtddlEditSiteStateIdChange() {
    $("#txtEditSiteStateId").val($("#ddlEditSiteStateId").val());
    if (isEditing) {
        $("#ddlEditSiteAreaId").val("");
        $("#txtEditSiteAreaId").val("");
    }
    editSiteCalculateRegionId();
}

//
// Functions
//
function editSiteToggleEditProfile() {
    if (!isEditing) {
        $("#editIcon")
            .removeClass("fa-pen")
            .addClass("fa-times");
        $("#divEditSiteDetails [js-readonly]").hide();
        $("#divEditSiteCancelSaveBtns, [js-edit]").removeClass("hidden");
        editSiteLoadCountry();
        $("#ddlEditSiteCountryCode").val($("#txtEditSiteCountryCode").val());
        evtddlEditSiteCountryCodeChange();
        $("#ddlEditSiteStateId").val($("#txtEditSiteStateId").val());
        editSiteLoadAreas($("#txtEditSiteAreaId").val());
    } else {
        $("#editIcon")
            .removeClass("fa-times")
            .addClass("fa-pen");
        $("#divEditSiteDetails [js-readonly]").show();
        $("#divEditSiteCancelSaveBtns, [js-edit]").addClass("hidden");
        editSiteClearSelects();
        editSiteRestoreOriginalValues();
        itiPhone.setNumber($("#txtEditSitePhoneNumber").val());
        $("#validationPhoneSpan").addClass("hidden");
   }
    isEditing = !isEditing;
}

function editSiteSaveOriginalValues() {
    $("#divEditSiteDetails")
        .find(":input:not([type='hidden'])")
        .each(function() {
            originalValues.push({
                id: $(this).attr("id"),
                value: $(this).is(":checkbox") ? $(this).is(":checked") : $(this).val(),
                type: $(this).attr("type") || $(this)[0].tagName
            });
        });
}

function editSiteRestoreOriginalValues() {
    for (let i = 0; i < originalValues.length; i++) {
        switch (originalValues[i].type.toLowerCase()) {
            case "email":
            case "select":
            case "text":
                $("#" + originalValues[i].id).val(originalValues[i].value);
                break;
            case "tel":
                $("#" + originalValues[i].id).val(originalValues[i].value);
                break;
            case "checkbox":
                $("#" + originalValues[i].id).prop("checked", originalValues[i].value);
                break;
        }
    }
    editSiteClearSelects();
}

function editSiteClearSelects() {
    $("#divEditSiteDetails")
        .find(":input[type='select']")
        .each(function() {
            $(this)
                .find("option")
                .not(":first")
                .remove()
                .end();
        });
}

function editSiteLoadCountry() {
    countryState
        .populateCountriesSelect("#ddlEditSiteCountryCode", "#divEditSiteNaState")
        .done(function() {
            const selectedCountry = $("#txtEditSiteCountryCode").val();
            countryState.populateStatesSelect("#divEditSiteNaState", "#divEditSiteNonNaState", selectedCountry);
            addressFormatter.maskPhone($("#txtEditSitePhoneNumber, #txtFax"), selectedCountry);
            addressFormatter.maskZip($("#txtEditSitePostalCode"), selectedCountry);
            addressFormatter.showIfUsOrCa($("#EditSiteNaPostalReq, #EditSiteNaStateReq"), selectedCountry);

            if (addressFormatter.isUsOrCa(selectedCountry)) {
                $("#txtEditSiteNonNaState").val("");
            }
        });
}

function editSiteCalculateRegionId() {
    const militaryValue = $("#chkEditSiteMilitary").is(":checked");
    const countryCodeValue = $("#txtEditSiteCountryCode").val();
    if (countryCodeValue === "") {
        return;
    }
    let stateIdValue = $("#txtEditSiteStateId").val();
    if (stateIdValue.trim() === "") {
        stateIdValue = "0";
    }
    dataaccess
        .get({
            url:
                "/api/Region/GetRegionId/" +
                militaryValue +
                "/" +
                countryCodeValue +
                "/" +
                stateIdValue
        })
        .done(function(result) {
            $("#hdnEditSiteRegionId").val(result);
            $("#txtEditSiteRegionId").val(result);
            editSiteLoadAreas();
        })
        .fail(function() {
            $("#hdnEditSiteRegionId").val(0);
            $("#txtEditSiteRegionId").val(0);
            editSiteLoadAreas();
        });
}

function editSiteLoadAreas(defaultValue) {
    const regionId = $("#hdnEditSiteRegionId").val();
    const countryCodeValue = $("#txtEditSiteCountryCode").val();
    if (countryCodeValue.trim() === "") {
        return;
    }
    let stateIdValue = $("#txtEditSiteStateId").val();
    if (stateIdValue.trim() === "") {
        stateIdValue = "0";
    }
    $("#ddlEditSiteAreaId")
        .find("option")
        .not(":first")
        .remove()
        .end();

    dataaccess
        .get({
            showSpinner: true,
            url:
                "/api/area/GetAreasForRegionId/" +
                regionId +
                "/" +
                countryCodeValue +
                "/" +
                stateIdValue
        })
        .done(function(results) {
            for (let i = 0; i < results.length; i++) {
                if (results[i].selected === true) {
                    $("#ddlEditSiteAreaId").append(
                        "<option value='" +
                        results[i].areaId +
                        "' selected>" +
                        results[i].areaName +
                        "</option>"
                    );
                } else {
                    $("#ddlEditSiteAreaId").append(
                        "<option value='" +
                        results[i].areaId +
                        "'>" +
                        results[i].areaName +
                        "</option>"
                    );
                }
            }
            if (defaultValue !== undefined) {
                $("#ddlEditSiteAreaId").val(defaultValue);
            }
        })
        .fail(function() {
            $("#ddlEditSiteAreaId").append(
                "<option value='" + 0 + "'>" + "Error Getting Areas" + "</option>"
            );
        });
}

function validateAndSubmitForm() {
    const $form = $(this).closest("form");

    if (!$form.valid()) {
        return;
    }

    if ($("#txtEditSitePhoneNumber").val() !== "" && !itiPhone.isValidNumber()) {
        $("#validationPhoneSpan").removeClass("hidden");
        return;
    }

    $("#txtEditSitePhoneNumber").val(itiPhone.getNumber());

    $form.submit();
}


export const siteProfile = {
    init: init
};
